// extracted by mini-css-extract-plugin
export default {"bio":"personPageBio_bio__tWDxV","bio_text":"personPageBio_bio_text__bJZob"};